import React from 'react'
import SOPTable from './Table/SOPTable'

export default function TableSOPUI({ selectedItemName, sopData, selectedType, isSingleModel }) {
  return (
    <div className='h-full'>
      <SOPTable selectedItemName={selectedItemName} sopData={sopData} selectedType={selectedType} isSingleModel={isSingleModel} />
    </div>
  )
}
